import http from "@/http/aisea/axios";
const resource =
  "/enterprises/manning/vessels/roles/positions/display_in_manning_tables";

/**
 * ポジションの表示・非表示設定リポジトリ
 */
export default {
  /**
   * ポジションの表示・非表示保存
   * @param {*} data
   * @returns
   */
  update(data) {
    return http.put(resource, data);
  },
};
